import React, { useContext } from 'react';

import TopFilterItem from './TopFilterItem';
import Context from "../context/context";

function TopFilters(props){


    const {
        form,
        } = props;



    if (form.length < 1){
      return (
        <></>
      );
    }

    const {
      selectedFilters, setSelectedFilters,
      activeFilters, setActiveFilters
    } = useContext(Context);

    const handleTopFilterItemClick = (id) => {

        let updated_filters = selectedFilters.map((selected_filter) => {
            if (selected_filter.name === "top_filter"){
                selected_filter.elements.map((element) => {
                    if (element.id === id) {
                        element.value = true;
                    } else {
                        element.value = false;
                    }
                    return element;

                })
            }
            return selected_filter;
        })
        setSelectedFilters(updated_filters);
    }

    const closeFilterPanel = () => {
        let active_filters = {
            mobile_open: false,
            active_panel: 'top_filter',
            top_filter_open: false,
            side_filter_open: false,
            active_side_filter: '',
            active_date_panel: ''
        };

        setActiveFilters(
          active_filters
        )
    }

    const resetTopFilters = () => {

        let selected_filters = selectedFilters.map((selected_filter) => {
          if (selected_filter.name === 'top_filter'){

            selected_filter.elements.forEach((element) => {
                element.value = false;

                if (element.id === "all"){
                  element.value = true;
                }
            })
          }


            return selected_filter;
        })
        setSelectedFilters(selected_filters);
    }

    return (
        <>
          <div className="top-filter ">
            {form.title &&
                <div className="top-filter-title">{form.title}</div>
            }
            <div className="top-filter-items">
                {form.elements.map(element =>
                    <TopFilterItem key={element.id} data={element} handleClick={() => handleTopFilterItemClick(element.id)}/>
                )}
            </div>

            <div className="filter-actions">
                <button
                className="filter-action view button button-white"
                onClick={() => closeFilterPanel()}
                >
                View results
                </button>
                <button
                    className="filter-action reset button"
                    onClick={() => resetTopFilters()}
                >
                Reset these filters
                </button>
            </div>
          </div>
        </>
    )
}

export default TopFilters;
